<template>
  <div class="animated fadeIn" style="padding-bottom: 30px">
    <b-row>
      <b-col md="12">
        <component-header
          title="Create Delivery Setup"
          :hasSearch="false"
          :hasReload="false"
          :hasCreate="false"
          :hasback="true"
          @back-press="$router.push('/setup/deliverysetup')"
        />
      </b-col>
      <ValidationObserver v-slot="{ invalid }" ref="observer">
        <b-col md="12">
          <b-card>
            <b-row>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    v-if="!checkDefaultState"
                    rules="required"
                    v-slot="{ errors }"
                    name="State"
                  >
                    <b-form-input
                      :inputId="`state`"
                      v-if="!checkDefaultState"
                      inputType="text"
                      required
                      placeholder="State *"
                      v-model="inputObject.state"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <b-form-input
                    v-if="checkDefaultState"
                    :inputId="`AppliedForAllCityStateCatergories`"
                    inputType="text"
                    size="md"
                    value="Applied for all states"
                    readonly
                  >
                  </b-form-input>

                  <div class="mt-1">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="checkDefaultState"
                      name="checkbox-1"
                      :value="true"
                      :unchecked-value="false"
                    >
                      Appl{{ checkDefaultState ? "ied" : "y" }} for all states
                    </b-form-checkbox>
                  </div>
                </div>
              </b-col>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    v-if="!checkDefaultCity"
                    rules="required"
                    v-slot="{ errors }"
                    name="City"
                  >
                    <b-form-input
                      v-if="!checkDefaultCity"
                      :inputId="`city`"
                      inputType="text"
                      placeholder="City *"
                      v-model="inputObject.city"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <b-form-input
                    v-if="checkDefaultCity"
                    :inputId="`AppliedForAllCityStateCatergories`"
                    inputType="text"
                    size="md"
                    value="Applied for all Cities"
                    readonly
                  >
                  </b-form-input>

                  <div class="mt-1">
                    <b-form-checkbox
                      id="checkbox-2"
                      v-model="checkDefaultCity"
                      name="checkbox-2"
                      :value="true"
                      :unchecked-value="false"
                    >
                      Appl{{ checkDefaultCity ? "ied" : "y" }} for all cities
                    </b-form-checkbox>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    v-if="!checkDefaultSourceState"
                    rules="required"
                    v-slot="{ errors }"
                    name="Source State"
                  >
                    <b-form-input
                      :inputId="`sourceState`"
                      v-if="!checkDefaultSourceState"
                      inputType="text"
                      required
                      placeholder="Source State *"
                      v-model="inputObject.sourceState"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <b-form-input
                    v-if="checkDefaultSourceState"
                    :inputId="`AppliedForAllCitySourceStateCatergories`"
                    inputType="text"
                    size="md"
                    value="Applied for all source states"
                    readonly
                  >
                  </b-form-input>

                  <div class="mt-1">
                    <b-form-checkbox
                      id="checkbox-3"
                      v-model="checkDefaultSourceState"
                      name="checkbox-3"
                      :value="true"
                      :unchecked-value="false"
                    >
                      Appl{{ checkDefaultSourceState ? "ied" : "y" }} for all
                      source states
                    </b-form-checkbox>
                  </div>
                </div>
              </b-col>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    v-if="!checkDefaultSourceCity"
                    rules="required"
                    v-slot="{ errors }"
                    name="Source City"
                  >
                    <b-form-input
                      v-if="!checkDefaultSourceCity"
                      :inputId="`sourcecity`"
                      inputType="text"
                      placeholder="Source City *"
                      v-model="inputObject.sourceCity"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <b-form-input
                    v-if="checkDefaultSourceCity"
                    :inputId="`AppliedForAllSourceCity`"
                    inputType="text"
                    size="md"
                    value="Applied for all source cities"
                    readonly
                  >
                  </b-form-input>

                  <div class="mt-1">
                    <b-form-checkbox
                      id="checkbox-4"
                      v-model="checkDefaultSourceCity"
                      name="checkbox-4"
                      :value="true"
                      :unchecked-value="false"
                    >
                      Appl{{ checkDefaultSourceCity ? "ied" : "y" }} for all
                      source cities
                    </b-form-checkbox>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <!-- <b-col md="5">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="City"
              >
                <c-input
                  :inputId="`city`"
                  inputType="text"
                  lableText="City"
                  v-model="inputObject.city"
                />
                <span class="validate-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-col> -->
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Category"
                  >
                    <eb-select
                      id="catalog-id"
                      label="text"
                      v-model="inputObject.category"
                      :options="catalogList"
                      placeholder="Select Category *"
                    ></eb-select>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Transportmode"
                  >
                    <eb-select
                      v-model="inputObject.transportMode"
                      :options="transportmode"
                      label="label"
                      placeholder="Select Transportmode * "
                    ></eb-select>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required|max:6"
                    v-slot="{ errors }"
                    name="Area Code"
                  >
                    <c-input
                      :inputId="`AreaCode`"
                      inputType="number"
                      lableText="AreaCode "
                      v-model="inputObject.areacode"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Rank"
                  >
                    <eb-select
                      v-model="inputObject.rank"
                      :options="rankList"
                      placeholder="Rank * "
                    ></eb-select>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
              <!-- <b-col md="5">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="Default Charge"
              >
                <c-input
                  :inputId="`Default-Charge`"
                  inputType="number"
                  lableText="Default Charge *"
                  v-model="inputObject.dwf"
                />
                <span class="validate-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-col> -->
            </b-row>
            <b-row>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required|futureDisable"
                    v-slot="{ errors }"
                    name="start-date"
                  >
                    <label :for="`start-date`">Start Date *:</label>
                    <b-input
                      :id="`start-date`"
                      type="date"
                      style="height: 40px; padding: 0px 13px"
                      v-model="inputObject.startDate"
                    ></b-input>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required|futureDisable|afterDate:start-date"
                    v-slot="{ errors }"
                    name="end-date"
                  >
                    <label class="mt-n4" for="end-date">End Date *:</label>
                    <b-input
                      id="end-date"
                      type="date"
                      style="height: 40px; padding: 0px 13px"
                      v-model="inputObject.endDate"
                    ></b-input>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="!deliveryPartnerKeyCheck">
              <b-col md="5">
                <b-form-checkbox
                  id="checkbox-5"
                  v-model="deliveryByMe"
                  name="checkbox-5"
                  :value="true"
                  class="mt-2"
                  :unchecked-value="false"
                >
                  Delivery by me
                </b-form-checkbox>
              </b-col>
              <b-col md="5">
                <eb-select
                  v-if="!deliveryByMe"
                  v-model="selectDeliveryPartner"
                  :options="deliveryPartnerOptions"
                  label="name"
                  :placeholder="`Select ${setPlaceHolder} *`"
                ></eb-select>
              </b-col>
            </b-row>
            <b-row v-if="deliveryPartnerKeyCheck">
              <strong>Delivery will done by you</strong>
            </b-row>
          </b-card>
        </b-col>

        <b-col md="12">
          <h4>Distance Tier</h4>
          <div>
            <div v-for="(t, idx) in inputObject.distanceTier" :key="idx">
              <b-card
                border-variant="info"
                header-bg-variant="primary"
                header-text-variant="white"
                class="full-width"
              >
                <b-row class="justify-content-end p-1 pb-2">
                  <eb-button
                    v-if="idx == inputObject.distanceTier.length - 1"
                    style="color: white; font-weight: bold; float: right"
                    :text="`Create New Distance Tier`"
                    @click="onClickaddButton(null, true)"
                  ></eb-button>
                  <eb-button
                    v-if="inputObject.distanceTier.length > 1"
                    style="color: white; font-weight: bold; float: right"
                    class="ml-2"
                    :text="`Remove Distance Tier`"
                    @click="onClickaddButton(idx)"
                  ></eb-button>
                </b-row>
                <b-row>
                  <!-- style="background-color: var(--secondary)" -->
                  <b-col md="5" class="pl-0">
                    <div class="material-textfield" style="left: 14px">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Distance tier"
                      >
                        <input
                          :id="`tier-name-${idx}`"
                          placeholder=" "
                          type="text"
                          class="input-weight"
                          v-model="inputObject.distanceTier[idx].tier"
                        />
                        <label :for="`tier-name-${idx}`" class="label-weight"
                          >Distance Tier Name *</label
                        >
                        <br />
                        <span class="validate-error text-white">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col offset="1" md="3">
                    <div class="material-textfield">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Start range"
                      >
                        <input
                          :id="`start-range-km-${idx}`"
                          placeholder=" "
                          type="number"
                          class="input-weight"
                          v-model="inputObject.distanceTier[idx].from"
                        />
                        <label
                          :for="`start-range-km-${idx}`"
                          class="label-weight"
                          >Start Range(KM) *</label
                        >
                        <br />
                        <span class="validate-error text-white">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="3" class="pr-0">
                    <div class="material-textfield" style="right: 14px">
                      <ValidationProvider
                        :rules="{
                          required: true,
                          min_value: inputObject.distanceTier[idx].from,
                        }"
                        v-slot="{ errors }"
                        name="End range"
                      >
                        <input
                          :id="`end-range-km-${idx}`"
                          placeholder=" "
                          type="number"
                          class="input-weight"
                          v-model="inputObject.distanceTier[idx].to"
                        />
                        <label :for="`end-range-km-${idx}`" class="label-weight"
                          >End Range(KM) *</label
                        >
                        <br />
                        <span class="validate-error text-white">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                </b-row>
                <b-row
                  v-for="(p, wIdx) in inputObject.distanceTier[idx].weight"
                  :key="wIdx"
                  class="p-0 mt-3"
                >
                  <b-col md="3">
                    <div class="material-textfield">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Start range"
                      >
                        <c-input
                          :inputId="`start-range-kg-${idx}-${wIdx}`"
                          inputType="number"
                          lableText="Start range (KG) *"
                          v-model="
                            inputObject.distanceTier[idx].weight[wIdx].from
                          "
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="3">
                    <div class="material-textfield">
                      <ValidationProvider
                        :rules="{
                          required: true,
                          min_value:
                            inputObject.distanceTier[idx].weight[wIdx].from,
                        }"
                        v-slot="{ errors }"
                        name="End range"
                      >
                        <c-input
                          :inputId="`end-range-kg-${idx}-${wIdx}`"
                          inputType="number"
                          lableText="End range (KG) *"
                          v-model="
                            inputObject.distanceTier[idx].weight[wIdx].to
                          "
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="3">
                    <div class="material-textfield">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Customer cost"
                      >
                        <c-input
                          :inputId="`customer-cost-${idx}-${wIdx}`"
                          inputType="number"
                          lableText="Customer Cost *"
                          v-model="
                            inputObject.distanceTier[idx].weight[wIdx]
                              .customerFee
                          "
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="3">
                    <div class="material-textfield">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Delivery cost"
                      >
                        <c-input
                          :inputId="`delivery-cost-${idx}-${wIdx}`"
                          inputType="number"
                          lableText="Delivery Cost *"
                          v-model="
                            inputObject.distanceTier[idx].weight[wIdx]
                              .deliveryAgentFee
                          "
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="3">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Unit"
                    >
                      <eb-select
                        id="catalog-id"
                        label="label"
                        :options="uomList"
                        v-model="
                          inputObject.distanceTier[idx].weight[wIdx].etd.uom
                        "
                        placeholder="Expected *"
                        style="background-color: white; height: 30px !important"
                      ></eb-select>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col md="3">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Time"
                    >
                      <c-input
                        :inputId="`delivery-time-${idx}-${wIdx}`"
                        inputType="number"
                        lableText="Time *"
                        v-model="
                          inputObject.distanceTier[idx].weight[wIdx].etd.time
                        "
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
              <b-col>
                <b-button
                     btn-special="deliverybtn"
                     size="lg"
                     class="no-focus-border"
                     :style="{
                     backgroundColor:
                     inputObject.distanceTier[idx].weight.length > 1 ? 'var(--danger)' : 'var(--secondary)',
                     color: 'white',
                     border: inputObject.distanceTier[idx].weight.length > 1
                     ? '1px solid var(--danger)'
                     : '1px solid var(--primary)'
                     }"
                    @click="onClickButton(idx, wIdx)"
                     >
                    <i
                     class="fa fa-minus-circle"
                    v-if="inputObject.distanceTier[idx].weight.length > 1"
                   ></i>
                   <i class="fa fa-plus-circle" v-else></i>
                   </b-button>
                   <b-button
                   v-if="wIdx > 0 && wIdx === inputObject.distanceTier[idx].weight.length - 1"
                   btn-special="deliverybtn"
                   size="lg"
                   class="ml-3 no-focus-border"
                   :style="{
                   backgroundColor: 'var(--secondary)',
                   color: 'white',
                   border: '1px solid var(--primary)'
                   }"
                  @click="onClickButton(idx, null, true)"
                  >
                  <i class="fa fa-plus-circle"></i>
                </b-button>
              </b-col>
              </b-row>
              </b-card>
             </div>
            <div class="text-center mt-3">
              <button
                type="button"
                class="btn btn-primary mr-4 save-btn"
                :disabled="invalid"
                text="Save"
                @click.prevent="handleSubmit"
              >
                Save
              </button>
            </div>
          </div>
        </b-col>
      </ValidationObserver>
    </b-row>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
  Validator,
} from "vee-validate/dist/vee-validate.esm";
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import { mapGetters } from "vuex";
import currentUser from "@/mixins/currentUser";
import moment from "moment";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  name: "CreateDeliverySetup",
  mixins: [currentUser],
  components: {
    ebButton,
    cInput,
    ValidationProvider,
    ValidationObserver,
    ebSelect,
    ComponentHeader,
  },
  data: () => {
    return {
      setPlaceHolder: "",
      show: true,
      deliveryPartnerKeyCheck: false,
      deliveryByMe: true,
      selectDeliveryPartner: "",
      checkDefaultCity: true,
      checkDefaultState: true,
      checkDefaultSourceCity: true,
      checkDefaultSourceState: true,
      uomSelect: "",
      inputObject: {
        city: "",
        sourceState: "",
        sourceCity: "",
        category: "",
        transportMode: "",
        startDate: "",
        endDate: "",
        rank: "",
        areacode: "",
        state: "",

        distanceTier: [
          {
            tier: "",
            from: "",
            to: "",
            isRemovable: false,
            weight: [
              {
                from: "",
                to: "",
                customerFee: "",
                deliveryAgentFee: "",
                isRemovable: false,
                etd: {
                  time: "",
                  uom: "",
                },
              },
            ],
          },
        ],
      },
      catalogList: [],
      uomList: ["days", "minutes", "hours"],
      transportmode: [
        {
          label: "Air ",
          value: "AIR",
        },
        {
          label: "Ship ",
          value: "SHIP",
        },
        {
          label: "Truck ",
          value: "TRUCK",
        },
        {
          label: "Bike ",
          value: "BIKE",
        },
      ],
      rankList: [2, 4, 6, 9],
    };
  },
  watch: {
    checkDefaultState() {
      this.inputObject.state = "";
    },
    checkDefaultCity() {
      this.inputObject.city = "";
    },
    checkDefaultSourceState() {
      this.inputObject.sourceState = "";
    },
    checkDefaultSourceCity() {
      this.inputObject.sourceCity = "";
    },
  },
  computed: {
    ...mapGetters({
      provider: "auth/getUserID",
    }),
    deliveryPartnerOptions() {
      try {
        let data = this.$store.getters["partner/GetPartnerList"];
        let partnerData = [];
        if (Array.isArray(data) && data.length > 0) {
          data.map((obj) => {
            partnerData.push({
              name: obj.authentication.userName,
              ...obj,
            });
          });
          return partnerData;
        } else {
          return [];
        }
      } catch {
        return [];
      }
    },
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  methods: {
    async getCatalogName() {
      let result = [];
      if (this.$userRole == "Tenant") {
        result = await this.$store.getters["catalog/GetTenantCatalogTree"];
      } else if (this.$userRole == "Partner") {
        result = this.$store.getters["catalog/GetPartnerCatalogTree"];
      }

      this.catalogList = result
        .filter((Obj) => Obj.isProductType)
        .map((c) => ({ text: c.name, value: c._id }));
      this.catalogList.push({ text: "All Categories", value: "*" });
      this.catalogList.reverse();
    },
    async onClickaddButton(idx, add = false) {
      if (this.inputObject.distanceTier.length > 1 && !add) {
        this.inputObject.distanceTier.splice(idx, 1);
      } else {
        this.inputObject.distanceTier.push({
          tier: "",
          from: "",
          to: "",
          weight: [
            {
              from: "",
              to: "",
              customerFee: "",
              deliveryAgentFee: "",
              etd: {
                time: "",
                uom: "",
              },
            },
          ],
        });
      }
    },
    async onClickButton(idx, wIdx, add = false) {
      if (this.inputObject.distanceTier[idx].weight.length > 1 && !add) {
        this.inputObject.distanceTier[idx].weight.splice(wIdx, 1);
      } else {
        this.inputObject.distanceTier[idx].weight.push({
          from: "",
          to: "",
          customerFee: "",
          deliveryAgentFee: "",
          isRemovable: true,
          etd: {
            time: "",
            uom: "",
          },
        });
      }
    },

    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let data = {
        state: this.inputObject.state,
        sourceState: this.inputObject.sourceState,
        rank: this.inputObject.rank,
        startDate: this.inputObject.startDate,
        endDate: this.inputObject.endDate,
        category: this.inputObject.category.value,
        city: this.inputObject.city,
        sourceCity: this.inputObject.sourceCity,
        transportMode: this.inputObject.transportMode.value,
        dwf: 5000,
        distanceTier: this.inputObject.distanceTier,
        areaCode: this.inputObject.areacode,
      };

      if (this.deliveryByMe) {
        data.deliveryOwner = {
          _id: this.$currentUserData._id,
          name: this.$currentUserData.userName,
          email: this.$currentUserData.email,
          phone: this.$currentUserData.phone,
          category:
            this.$currentUserData.category == "TA"
              ? "TENANT"
              : this.$currentUserData.category,
        };
      } else {
        try {
          data.deliveryOwner = {
            _id: this.selectDeliveryPartner._id,
            name: this.selectDeliveryPartner.authentication.userName,
            email: this.selectDeliveryPartner.authentication.email,
            phone: this.selectDeliveryPartner.authentication.phone,
            category: this.selectDeliveryPartner.category,
          };
        } catch {}
      }

      data.distanceTier.forEach((obj) => {
        delete obj.isRemovable;
        obj.weight.forEach((element) => {
          delete element.isRemovable;
        });
      });

      if (this.checkDefaultState) {
        data.state = "*";
      } else {
      }
      if (this.checkDefaultCity) {
        data.city = "*";
      } else {
      }

      if (this.checkDefaultSourceState) {
        data.sourceState = "*";
      } else {
      }

      if (this.checkDefaultSourceCity) {
        data.sourceCity = "*";
      } else {
      }
      const response = await this.$store
        .dispatch("delivery/createdeliverySetup", data)
        .then(() => {
          this.$swal({
            title: "Success",
            text: "Delivery setup details  added successfully!!",
            type: "success",
          });
        })
        .catch((err) => {
          this.$swal({
            title: "Opps!!!!!!",
            text: "Sorry Unable to Create Delivery setup!!",
            type: "error",
          });
        });
      this.$router.push("/setup/deliverysetup");
      this.$store.dispatch("delivery/fetchdeliverysList");
    },
  },
  async mounted() {
    if (this.$userRole == "Tenant") {
      if (!this.$store.getters["catalog/GetTenantCatalogTree"].length > 0) {
        await this.$store.dispatch("catalog/fetchTenantCatalogTree");
      } else {
      }
    } else if (this.$userRole == "Partner") {
      if (!this.$store.getters["catalog/GetPartnerCatalogTree"].length > 0) {
        await this.$store.dispatch("catalog/fetchPartnerCatalogTree");
      } else {
      }
    }

    this.getCatalogName();
    if (this.$userRole == "Tenant") {
      await this.$store.dispatch(
        "partner/listPartnerTypeFilterAction",
        "DISTRIBUTOR"
      );
      this.setPlaceHolder = "Distributor";
    } else if (this.$userRole == "Partner") {
      if (this.$currentUserData.category == "DISTRIBUTOR") {
        await this.$store.dispatch(
          "partner/listPartnerTypeFilterAction",
          "DEALER"
        );
        this.setPlaceHolder = "Dealer";
      } else if (this.$currentUserData.category == "DEALER") {
        await this.$store.dispatch(
          "partner/listPartnerTypeFilterAction",
          "SELLER"
        );
        this.setPlaceHolder = "Seller";
      } else if (this.$currentUserData.category == "SELLER") {
        this.deliveryPartnerKeyCheck = true;
      }
    }
    Validator.extend(
      "afterDate",
      (value, [otherValue]) => {
        return moment(value).diff(this.inputObject.startDate, "hour") >= 0;
      },
      {
        hasTarget: true,
      }
    );
    Validator.extend(
      "futureDisable",
      (value, [otherValue]) => {
        return moment().diff(this.inputObject.startDate, "hour") >= 0;
      },
      {
        hasTarget: true,
      }
    );
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
.myDIV:hover + .hide {
  display: block;
  position: absolute;
}
.hide {
  display: none;
  font-size: 11px;
}

.container-fluid {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  /* background-color: #e5e5e5; */
}
.back-button {
  color: white;
  font-weight: bold;
  float: right;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

[btn-special="deliverybtn"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  height: 36px;
  width: 44px;
 color: white;
}
.no-focus-border:focus,
.no-focus-border:active,
.no-focus-border:hover {
  box-shadow: none !important;
  outline: none !important;
}
.btn btn-primary {
  width: 25px;
}
.save-btn {
  width: 110px;
  font-size: 15px;
  
}
</style>
